import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { ImagesActionTypes } from './types'
import { fetchError, fetchSuccess } from './actions'
import { db } from '../../components/firebase'

// import projectdirectories from '../../data/directories.json'
// import eventdirectories from '../../data/directoriesEvents.json'
// import images from '../../data/images.json'

function getGalleryPromise(id: number) {
  let promise = () =>
    db
      .FindImageGallery(id)
      .get()
      .then(querySnapshot => {
        // console.log(querySnapshot.docs)
        return querySnapshot.docs
      })
  return promise()
}
function getImages() {
  let promise = () =>
    db
      .onceImages()
      .get()
      .then(querySnapshot => {
        console.log(querySnapshot.docs)
        return querySnapshot.docs
      })
  return promise()
}
function* FindStorageURL(storageRef: any, str: string) {
  // console.log('FindStorageURL')
  let image = storageRef.child(str)
  let promise = () =>
    image.getDownloadURL().then(url => {
      // console.log(url)

      return {
        url,
        str
      }
    })
  const result = yield promise()
  return result
}
function UpdateImages() {
  images.map(image => {
    if (image.id > 2949) {
      db.onceImages()
        .add(image)
        .then(function() {
          console.log('Document ' + image.location + ' successfully updated!')
        })
        .catch(function(error) {
          console.error('Error adding document: ', error)
        })
    }
  })
}
function* bulkUpdate({ payload }) {
  // UpdateImages()
  console.log('bulkUpdate gallery', payload)
  if (payload != null) {
    const storageRef = db.storageRef()
    try {
      const gallery = yield getGalleryPromise(payload)
      // const gallery = yield getImages()
      // const gallery = yield call(getGalleryPromise(payload))
      console.log(gallery)
      for (let img of gallery) {
        console.log(img.data())
        if (img.data().location.indexOf('http') === -1) {
          let location = img
            .data()
            .location.trim()
            .toLowerCase()
          if (location.indexOf('~') != -1) {
            location = location.replace('~', '')
          }
          // projectdirectories.concat(eventdirectories).map(folder => {
          //   location = location.replace('/' + folder + '/', '/' + folder.toLowerCase() + '/')
          // })
          // if (location.indexOf('/sonicimpairment/') != -1) {
          //   location = location.replace('/sonicimpairment/', '/projects/sonicimpairment/')
          // }
          const result = yield call(FindStorageURL, storageRef, location)
          result.original = img.data().location
          console.log(result)
          db.GetImageDoc(img.id)
            .update({
              location_old:
                img.data().location_old == null ? img.data().location : img.data().location_old,
              location: result.url
            })
            .then(function() {
              console.log('Document ' + img.data().name + ' successfully updated!')
            })
        }
      }
    } catch (err) {
      console.log(err)
      if (err instanceof Error) {
        yield put(fetchError(err.stack!))
      } else {
        yield put(fetchError('An unknown error occured.'))
      }
    }
  }
}

function* handleFetch({ payload }) {
  // saveLogin()

  // console.log('handle image', arguments)
  try {
    const res = yield getGalleryPromise(payload)
    yield put(fetchSuccess(res.map(item => item.data())))
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  // console.log('watch ', arguments)
  yield takeEvery(ImagesActionTypes.FETCH_REQUEST, handleFetch)
}
function* watchBulkRequest() {
  // console.log('watchBulkRequest ', arguments)
  yield takeEvery(ImagesActionTypes.BULK_UPDATE, bulkUpdate)
}
// We can also use `fork()` here to split our saga into multiple watchers.
function* ImagesSaga() {
  // console.log('---')
  yield all([fork(watchFetchRequest), fork(watchBulkRequest)])
}

export default ImagesSaga
